/**
 * Company: SPHMedia
 * Description: [Following tags page block]
 */

import ShuffleButton from "@elements/Buttons/ShuffleButton";
import FollowTopicsButton from "@elements/FollowTopicsButton/FollowTopicsButton";
import { ReactElement } from "react";

import { TopicsData } from "./FollowTrendingTopics";

export type FollowTopicsPageVariantProps = {
  topicsData: TopicsData[];
  onFollow: (topicIds: string, topicTitle: string) => Promise<void>;
  onUnfollow: (topicIds: string, topicTitle: string) => Promise<void>;
  onShuffle: () => Promise<void>;
  selected: string[];
  unSelect: (topicId: string, topicTitle: string) => Promise<void>;
  loadingTopicId: string | null;
};

/**
 * FollowTopicsPageVariant
 * Description: [List trending topics on following tags page]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function FollowTopicsPageVariant({
  topicsData,
  onFollow,
  onUnfollow,
  onShuffle,
  selected = [],
  unSelect,
  loadingTopicId,
}: FollowTopicsPageVariantProps): ReactElement {
  // Add component logic and state here

  return (
    <div data-testid="follow-trending-tags" className="w-full max-w-[500px]">
      <div className="flex flex-col gap-6 justify-center">
        <div className="flex justify-center gap-1">
          <span className="text-text-body text-md font-secondary font-medium leading-[120%] max-w-[248px] md:max-w-[260px] text-center">
            Pilih topik kegemaran anda untuk membentuk menu berita tersendiri
          </span>
        </div>
        <div className="flex flex-col items-start gap-3">
          <div className="flex w-full gap-3 flex-wrap justify-center items-center">
            {topicsData.length > 0 ? (
              topicsData.map((item, index) => (
                <FollowTopicsButton
                  key={`${item.topicId}-${index}`}
                  variant="primary"
                  label={item.label}
                  topicId={item.topicId}
                  onFollow={onFollow}
                  onUnfollow={onUnfollow}
                  isFollowing={item.isFollowing}
                  isTrending={item.isTrending}
                  selected={selected.includes(item.topicId) ? true : false}
                  unSelect={unSelect}
                  isLoading={loadingTopicId === item.topicId}
                />
              ))
            ) : (
              <span className="text-text-body text-xxs">
                No trending topics available
              </span>
            )}
          </div>
          <div className="flex justify-center w-full">
            <ShuffleButton onShuffle={onShuffle} variant="blue" />
          </div>
        </div>
      </div>
    </div>
  );
}
